/* ============================================================
   VIENTRE DE PAPEL – LÁMINAS (Estándar / Personalizado)
   - Varianti Shopify dal DOM
   - Cambio prezzo live
   - Cambio variante Shopify automatico
   - Descrizione dinamica
   - Campi dinamici per Personalizado
   - Gestione quantità (Pack 1, Pack 2, ...)
   ============================================================ */

document.addEventListener("DOMContentLoaded", function () {

  const wrapper  = document.querySelector(".vp-laminas-wrapper");
  if (!wrapper) return;

  const botones  = wrapper.querySelectorAll(".vp-boton-tipo");
  const priceEl  = document.querySelector(".price-item--regular");
  const descZone = document.querySelector("#vp-descripcion-laminas");
  const detalles = document.querySelector("#vp-detalles-laminas");

  function parseVariantPrice(value) {
    return parseFloat(String(value || "").trim().replace(",", "."));
  }

  /* ------------------------------------------------------------
     1 — CARICA VARIANTI REALI DAL DOM
     ------------------------------------------------------------ */
  function loadVariantPrices() {
    const variantes = Array.from(document.querySelectorAll("[data-product-variant]"));
    const map = {};

    variantes.forEach(v => {
      const id    = parseInt(v.dataset.variantId, 10);
      const price = parseVariantPrice(v.dataset.variantPrice);
      const opt   = v.dataset.variantOption?.toLowerCase().trim();

      if (opt.includes("personal")) {
        map.personalizado = { id, price };
      } else {
        map.estandar = { id, price };
      }
    });

    return map;
  }

  const VP_LAMINAS = loadVariantPrices();
  console.log("VARIANTI LETTE:", VP_LAMINAS);

  /* ------------------------------------------------------------
     2 — UTILITIES
     ------------------------------------------------------------ */
  function tipoActivo() {
    const activo = wrapper.querySelector(".vp-boton-tipo.is-active");
    if (!activo) return "estandar";

    let tipo = activo.dataset.tipo.toLowerCase().trim();
    tipo = tipo.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    return tipo.includes("personal") ? "personalizado" : "estandar";
  }

  function getVariantInput() {
    return document.querySelector('product-form form input[name="id"]');
  }

  function getQtyInput() {
    return document.querySelector('input[name="quantity"]');
  }

  function cantidad() {
    const input = getQtyInput();
    const v = input ? parseInt(input.value, 10) : 1;
    return isNaN(v) || v < 1 ? 1 : v;
  }

  /* ------------------------------------------------------------
     3 — CAMBIO VARIANTE + PREZZO LIVE
     ------------------------------------------------------------ */
  function updateVariantAndPrice() {
    const idInput = getVariantInput();
    const tipo = tipoActivo();
    const varData = VP_LAMINAS[tipo];
    if (!idInput || !varData) return;

    idInput.value = varData.id;

    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* ------------------------------------------------------------
     4 — DESCRIZIONE DINAMICA
     ------------------------------------------------------------ */
  function renderDescripcion() {
    const tipo = tipoActivo();

    let html = `
      <p>Pack de 8 láminas con bonitos diseños y frases inspiradoras que toda mamá debe repetirse y no olvidar jamás.</p>
      <p>Repártelas por toda la casa y léelas en voz alta siempre que pases por delante.</p>
    `;

    if (tipo === "personalizado") {
      html += `
        <p><strong>Para hacer este regalo aún más especial, puedes personalizarlo con el nombre de la mamá, ¡le encantará!</strong></p>
      `;
    }

    descZone.innerHTML = html;
  }

  /* ------------------------------------------------------------
     5 — CAMPI DINAMICI (Nombre de la mamá) + quantità
     ------------------------------------------------------------ */
  function renderDetalles() {
    const tipo = tipoActivo();
    const cant = cantidad();
    let html = "";

    if (tipo === "estandar") {
      detalles.innerHTML = "";
      return;
    }

    // PERSONALIZADO → genera blocchi numerati
    for (let i = 1; i <= cant; i++) {
      html += `
        <div class="vp-pack-bloque">
          <h4 class="vp-pack-titulo">Pack de Láminas ${i}</h4>

          <label class="vp-label-campo">Nombre de la mamá</label>
          <input type="text" class="vp-input" name="properties[Lámina ${i} - Nombre mamá]"><br>
        </div>
      `;
    }

    detalles.innerHTML = html;
  }

  /* ------------------------------------------------------------
     6 — EVENTI
     ------------------------------------------------------------ */
  botones.forEach(btn => {
    btn.addEventListener("click", () => {
      botones.forEach(b => b.classList.remove("is-active"));
      btn.classList.add("is-active");

      updateVariantAndPrice();
      renderDescripcion();
      renderDetalles();
    });
  });

  // Cambio quantità manuale
  document.body.addEventListener("input", e => {
    if (e.target.matches('input[name="quantity"]')) {
      renderDetalles();
    }
  });

  // Cambio quantità con + e -
  document.body.addEventListener("click", e => {
    if (e.target.closest(".quantity__button")) {
      setTimeout(() => {
        renderDetalles();
      }, 50);
    }
  });

  /* INIT */
  updateVariantAndPrice();
  renderDescripcion();
  renderDetalles();
});
